import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx'; // your JSX file

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
